import {
  AGGRESSION_PROMPT,
  COMPLEX_TO_SIMPLE_QUERY_PROMPT,
  CONTEXTUAL_RETRIEVAL_PROMPT,
  HYDE_PROMPT,
  ITERATIVE_DECONSTRUCTION,
  KG_TRIPLET_EXTRACT_TMPL,
  LLAMA_PARSE_PROMPT,
  MULTI_QUERY_PROMPT,
  QUERY_EXPANSION,
  TEXT_TO_NO_SQL_PROMPT,
} from "./defaultPrompts";

export const botDataDefault = {
  rqa_prompt: "You are a helpful assistant", /// remove later
  advancedMode: false,
  organization: "",
  creator: "",
  name: "Untitled application",
  problem_statement: "I want a helpful assistant.",
  "llm-finetuning": false,
  datasets: [],
  structured_datasets: [],
  finetuning_dataset: [],
  dynamicShot_dataset: [],
  prompt_combinations: { "zero-shot": "You are a helpful assistant." },
  query_preprocessing_prompts: {
    retrieval_1: {
      complex_to_simple: COMPLEX_TO_SIMPLE_QUERY_PROMPT,
      query_expansion: QUERY_EXPANSION,
      multi_query: MULTI_QUERY_PROMPT,
      hyde: HYDE_PROMPT,
      iterative_deconstruction: ITERATIVE_DECONSTRUCTION,
    },
  },
  golden_responses: [],
  golden_responses_option: "userQna",
  optimization_method: "grid-search",
  have_memory: true,
  response_length: {
    "detailed-answers": false,
    concise: false,
    "no-preference": true,
  },
  response_length_text: "",
  recency: false,
  recency_text: "",
  tone: { formal: false, informal: false, "no-preference": true },
  tone_text: "",
  latency: { critical: true, noCritical: false },
  references: false,
  references_text: "",
  sources: true,
  sources_text: "\nReturn sources of the documents used in context.",
  structured_file: null,
  columnTypes: {},
  metadataDescription: {},
  workflow: {},
  headers: [],
  foundational: true,
  unstructuredColumnTypes: {},
  neo4j_credentials: {
    NEO4J_URI: "",
    NEO4J_USERNAME: "",
    NEO4J_PASSWORD: "",
    llm: "",
  },
  neo_4j_prompts: {
    KG_TRIPLET_EXTRACT_TMPL: KG_TRIPLET_EXTRACT_TMPL,
  },
  retrieval_prompts: {
    contextual_retrieval_prompt: CONTEXTUAL_RETRIEVAL_PROMPT,
    chunk_window_size: "2",
  },
  text2nosql_prompt: {
    TEXT_TO_NO_SQL_PROMPT: TEXT_TO_NO_SQL_PROMPT,
  },
  parsing_instructions: {
    llama_parse_prompt: LLAMA_PARSE_PROMPT,
    splitters: {
      markdown: [
        "\\n#{1,6}",
        "```\\n",
        "\\n\\\\\\\\\\\\*+\\n",
        "\\n---+\\n",
        "\\n_+\\n",
        "\\n\\n",
        "\\n",
        " ",
        "",
      ],
      text: ["\\n\\n", "\\n", " ", ""],
      html: [
        "<body",
        "<div",
        "<p",
        "<br",
        "<li",
        "<h1",
        "<h2",
        "<h3",
        "<h4",
        "<h5",
        "<h6",
        "<span",
        "<table",
        "<tr",
        "<td",
        "<th",
        "<ul",
        "<ol",
        "<header",
        "<footer",
        "<nav",
        "<head",
        "<style",
        "<script",
        "<meta",
        "<title",
        "",
      ],
    },
    unstructuredio_mode: {
      fast: false,
      hi_res: false,
      auto: true,
      ocr_only: false,
    },
  },
  templates: false,
  text2nosql: false,
  "text2nosql-vectorsearch": true,
  aggregation_prompt: AGGRESSION_PROMPT,
};

export const generationDefault = {
  finetuning_values: {
    llm: { "llama-3-8b": false, "gpt-4o-mini-2024-07-18": true },
    epoch: { 1: true },
    learningRate: { 1: "true" },
    batchSize: { 2: "true" },
    optimization_method: "grid-search",
  },
  llm_params: {
    temperature: { 0: "true" },
    outputTokenLimit: { 0: "true" },
    llm: {
      "gpt-4o-mini": true,
      "gpt-4": false,
      "meta-llama/Meta-Llama-3-8B-Instruct-Turbo": false,
      "meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo": false,
      "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo": false,
      "meta-llama/Llama-3.2-11B-Vision-Instruct-Turbo": false,
      "meta-llama/Llama-3.2-90B-Vision-Instruct-Turbo": false,
      "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8": false,
      "meta-llama/Llama-4-Scout-17B-16E-Instruct": false,
      "claude-3-opus-20240229": false,
      "claude-3-sonnet-20240229": false,
      "claude-3-haiku-20240307": false,
      "claude-3-5-haiku-20241022": false,
      "claude-3-7-sonnet-20250219": false,
      "gemini-1.5-pro": false,
      "gemini-2.5-flash-preview-05-20": false,
      "gemini-2.0-flash": false,
      "gemini-2.5-pro-preview-05-06": false,
      "mistralai/Mixtral-8x22B-Instruct-v0.1": false,
      "mistralai/Mixtral-8x7B-Instruct-v0.1": false,
      "claude-sonnet-4-20250514": false,
      "claude-opus-4-20250514": false,
      o1: false,
      "o1-mini": false,
      "o3-2025-04-16": false,
      "o3-mini-2025-01-31": false,
      "o4-mini-2025-04-16": false,
      "gemini-1.5-flash-8b": false,
      "meta-llama/Llama-3.3-70B-Instruct-Turbo": false,
      "Qwen/Qwen3-235B-A22B-fp8-tput": false,
      "deepseek-ai/DeepSeek-V3": false,
      "deepseek-ai/DeepSeek-R1": false,
      "grok-3-latest": false,
      "grok-3-fast-latest": false,
      "grok-3-mini-latest": false,
      "grok-3-mini-fast-latest": false,
    },
    prompts: {
      "zero-shot": true,
      "few-shot": false,
      "few-shot-random": false,
      "dynamic-few-shot": false,
      "chain-of-thought": false,
      "few-shot-cot-random": false,
    },
  },
};

export const retrievalDefault = {
  chunksize: {
    300: true,
    700: false,
    1800: false,
    4200: false,
  },
  metric: {
    cosine: true,
    dotproduct: false,
    euclidean: false,
    hybrid: false,
    "cosine+sparse": false,
  },
  retrieval_method: {
    basic: true,
    "multi-query": false,
    hyde: false,
    "complex-to-simple-query": false,
    "sentence-window": false,
    "graphrag+basic": false,
    "graphrag+sentence-window": false,
    "graphrag+context_retrieval": false,
    context_retrieval: false,
  },
  rerank_method: {
    none: true,
    mmr: false,
    cohere: false,
    llm_rerank: false,
    pinecone: false,
    jina: false,
    nvidia: false,
    contextualai: false,
    llamarank: false,
  },
  top_k: {
    1: false,
    5: true,
    10: false,
    15: false,
    20: false,
    25: false,
    30: false,
    35: false,
    40: false,
  },
  embedding_model: {
    "text-embedding-ada-002": true,
    "fine-tuned": false,
    "text-embedding-3-small": false,
    "text-embedding-3-large": false,
    "voyage-law-2": false,
    "voyage-finance-2": false,
    "voyage-code-3": false,
    "voyage-3.5": false,
    "embed-v4.0": false,
  },
  parser: {
    recursive_character_text_splitter: true,
    unstructuredio: false,
    llama_parse: false,
  },
  query_preprocess_method: {
    basic: true,
    multi_query: false,
    hyde: false,
    complex_to_simple: false,
    query_expansion: false,
    iterative_deconstruction: false,
  },
  metadata_filtering: { "add-metadata": false, "no-metadata": true },
  applications: {
    "no-application": true,
    slack: false,
    telegram: false,
    googledrive: false,
  },
  tools: {
    "no-tools": true,
    calendly: false,
    traditionalDb: false,
    "payment-system": false,
  },
  knowledgebase: {
    "no-knowledgebase": true,
    csv: false,
    websites: false,
    drive: false,
  },
};

// helper: disable any listed keys on a bucket
export function disableKeys(bucket = {}, keys = []) {
  keys.forEach((k) => {
    if (k in bucket) bucket[k] = false;
  });
}

// helper: apply all “starter” restrictions to a workflow object
export function applyStarterLimits(workflow) {
  // 1) retrieval_1 restrictions
  const retrievalConfig = {
    chunksize: ["4200"],
    metric: ["euclidean", "hybrid"],
    embedding_model: [
      "text-embedding-3-large",
      "fine-tuned",
      "voyage-law-2",
      "voyage-finance-2",
      "voyage-code-3",
      "voyage-3.5",
      "embed-v4.0",
    ],
    parser: ["llama_parse", "unstructuredio"],
    query_preprocess_method: [
      "iterative_deconstruction",
      "complex_to_simple",
      "query_expansion",
    ],
    rerank_method: ["cohere"],
    retrieval_method: ["context_retrieval", "graphrag"],
    top_k: ["15", "20", "25", "30", "35", "40"],
  };

  const r1 = workflow.retrieval_1;
  if (r1) {
    for (const [category, keys] of Object.entries(retrievalConfig)) {
      disableKeys(r1[category], keys);
    }
  }

  // 2) generation* sections’ LLM bans
  const bannedModels = [
    "claude-3-5-sonnet-20241022",
    "claude-3-5-haiku-20241022",
    "claude-3-7-sonnet-20250219",
    "claude-3-opus-20240229",
    "claude-3-sonnet-20240229",
    "gemini-1.5-pro",
    "gemini-2.5-flash-preview-05-20",
    "gemini-2.5-pro-preview-05-06",
    "gpt-4",
    "gpt-4o",
    "meta-llama/Meta-Llama-3-8B-Instruct-Turbo",
    "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo",
    "meta-llama/Llama-3.2-11B-Vision-Instruct-Turbo",
    "meta-llama/Llama-3.2-90B-Vision-Instruct-Turbo",
    "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
    "meta-llama/Llama-4-Scout-17B-16E-Instruct",
    "mistralai/Mixtral-8x22B-Instruct-v0.1",
    "o1",
    "o1-mini",
    "gemini-1.5-flash-8b",
    "meta-llama/Llama-3.3-70B-Instruct-Turbo",
    "Qwen/Qwen3-235B-A22B-fp8-tput",
    "deepseek-ai/DeepSeek-V3",
    "deepseek-ai/DeepSeek-R1",
    "gpt-4.1-2025-04-14",
    "gpt-4.1-mini-2025-04-14",
    "gpt-4.1-nano-2025-04-14",
    "o3-2025-04-16",
    "o3-mini-2025-01-31",
    "o4-mini-2025-04-16",
    "grok-3-latest",
    "grok-3-fast-latest",
    "grok-3-mini-latest",
    "grok-3-mini-fast-latest",
  ];

  Object.keys(workflow).forEach((sectionKey) => {
    if (sectionKey.includes("generation")) {
      const llmBucket = workflow[sectionKey]?.llm_params?.llm;
      disableKeys(llmBucket, bannedModels);
    }
  });
}
